const getDiceBearUrl = (seed: string) => {
  const encodedSeed = encodeURIComponent(seed)
  return `https://api.dicebear.com/9.x/lorelei/svg?seed=${encodedSeed}`
}

export const resolveAvatarImageUrl = (
  src: string | undefined,
  seed: string | undefined,
  shouldLoad: boolean,
): string | undefined => {
  if (!shouldLoad) {
    return undefined
  }
  if (src) {
    return src
  }
  if (seed) {
    return getDiceBearUrl(seed)
  }
  return undefined
}
